


































































































































import {
  Component,
  Prop,
  Vue,
  Watch,
  Emit,
  Mixins
} from "vue-property-decorator";
import { State, Action } from "vuex-class";
import anime from "animejs";
import { Route } from "vue-router";
import ContentContainer from "../../components/ContentContainer.vue";
import BackgroundCurtainsAnimation from "../../mixins/BackgroundCurtainsAnimation";
import Button from "../../components/Button.vue";
import constants from "../../store/constants";

@Component({
  components: {
    ContentContainer,
    Button
  }
})
export default class ObjectPageFirstScreen extends Mixins(
  BackgroundCurtainsAnimation
) {
  @Prop() visibleScreenNumber!: number;
  @Prop() activeScreenNumber!: number;
  @Prop() screenNumber!: number;
  @State(state => state.app.loadingScreenAnimationEnded)
  loadingAnimationEnded!: boolean;
  @State(state => state.app.scrollingByScreens) scrollingByScreens!: boolean;

  $refs!: {
    root: HTMLElement;
    image: HTMLElement;
    bgWrap: HTMLElement;
    contentWrap: HTMLElement;
    bg: HTMLElement;
    requestAPrice: HTMLElement;
    signUpForViewing: HTMLElement;
    textBlock: HTMLElement;
  };

  @Emit("change-screen")
  changeScreen() { }

  buttonClick() {
    this.$store.dispatch(constants.showVideo, "cCfs9N-pBpQ");
  }

  mounted() { }

  get screenHeight() {
    return this.$browser.height < 350 ? 350 : this.$browser.height;
  }

  get containerHeight() {
    let height = this.scrollingByScreens
      ? this.screenHeight - 130
      : this.screenHeight - 70;
    return height;
  }

  @Watch("$browser.width")
  widthChange() {
    if (
      this.activeScreenNumber === this.screenNumber ||
      !this.scrollingByScreens
    ) {
      this.setWidthToCurtains();
    }
  }

  openLearnMoreForm() {
    window.dispatchEvent(new Event("openForm:learnMore"));
  }

  openRequestAPriceWindow() {
    window.dispatchEvent(new Event("openForm:requestAPrice"));
  }

  openSignUpForViewingForm() {
    window.dispatchEvent(new Event("openForm:singUpForViewing"));
  }

  /**************************************/
  /************* Анимации ***************/
  /**************************************/

  alreadyEntered = false;
  scaleAnimationEnded = false;

  /** Предыдущий экран уходит.*/
  @Watch("activeScreenNumber")
  activeScreenNumberChange(nextNumber: number, prevNumber: number) {
    // Переключение с этого экрана
    if (prevNumber == this.screenNumber && this.scrollingByScreens) {
      this.bgLeave(nextNumber == 2 ? true : false);
      this.screenLeave();
    }

    // Переключение на этот экран
    if (
      nextNumber == this.screenNumber &&
      (this.scrollingByScreens || !this.alreadyEntered)
    ) {
      this.bgEnter(prevNumber == 2 ? true : false);
    }
  }

  /** Следующий экран появляется*/
  @Watch("visibleScreenNumber")
  visibleScreenNumberChange(nextNumber: number, prevNumber: number) {
    // Переключение на этот экран
    if (
      nextNumber == this.screenNumber &&
      (this.scrollingByScreens || !this.alreadyEntered)
    ) {
      this.screenEnter(prevNumber);
      this.alreadyEntered = true;
    }

    if (nextNumber == this.screenNumber) {
      localStorage.setItem("screen", "Первый экран (Green Hills)");
    }
  }

  /** Появление */
  screenEnter(prevScreenNumber: number) {
    this.textEnterAnimation(prevScreenNumber);
  }

  /** Исчезание */
  screenLeave() {
    this.textLeave();
    setTimeout(() => {
      this.changeScreen();
    }, 800);
  }

  bgEnter(parallax: boolean) {
    if (this.scrollingByScreens) {
      this.$refs.bg.style.opacity = "1";
      if (!this.scaleAnimationEnded) {
        this.scaleAnimation();
        this.scaleAnimationEnded = true;
      } else if (parallax) {
        this.setWidthToCurtains();

        this.$refs.image!.style.transform = `translate3d(0, 50%, 0)`;
        this.$refs.bgWrap!.style.transform = `translate3d(0, -100%, 0)`;
        let transition = {
          value1: 0,
          value2: 1,
          value3: 0,
          value4: 100,
          value5: 50
        };

        anime({
          targets: transition,
          duration: 950,
          easing: "easeInOutQuad",
          value1: 100,
          value2: 0,
          value3: 1,
          value4: 0,
          value5: 0,
          update: () => {
            this.$refs.image!.style.transform = `translate3d(0, ${transition.value5}%, 0)`;
            this.$refs.bgWrap!.style.transform = `translate3d(0, -${transition.value4}%, 0)`;
          }
        });
      } else {
        this.$refs.image!.style.transform = `translate3d(0, 0%, 0)`;
        this.$refs.bgWrap!.style.transform = `translate3d(0, 0%, 0)`;
        this.curtainsEnterAnimation();
      }
    }
  }

  bgLeave(parallax: boolean) {
    this.$refs.image!.style.transform = `translate3d(0, 0%, 0)`;
    this.$refs.bgWrap!.style.transform = `translate3d(0, 0%, 0)`;
    if (parallax) {
      this.setWidthToCurtains();
      let transition = {
        value1: 0,
        value2: 1,
        value3: 0,
        value4: 100,
        value5: 0
      };

      anime({
        targets: transition,
        duration: 1000,
        easing: "easeInOutQuad",
        value1: 100,
        value2: 0,
        value3: 1,
        value4: 0,
        value5: 50,
        update: () => {
          this.$refs.image!.style.transform = `translate3d(0, ${transition.value5}%, 0)`;
          this.$refs.bgWrap!.style.transform = `translate3d(0, -${transition.value1}%, 0)`;
        }
      });
    } else {
      this.curtainsLeaveAnimation();
    }

    setTimeout(() => {
      this.$refs.bg.style.opacity = "0";
    }, 1500);
  }

  scaleAnimation() {
    let curtains = this.$refs.root.querySelectorAll(".curtain-mask-element");
    for (let index = 0; index < curtains.length; index++) {
      const curtain = curtains[index];
      curtain.setAttribute(
        "width",
        this.calcWidthForSection(index + 1).toString()
      );
    }

    anime({
      targets: this.$refs.image,
      scale: [1.6, 1],
      translateZ: 0,
      duration: 2000,
      easing: "easeOutQuad"
    });
  }

  textEnterAnimation(prevScreenNumber: number) {
    let delay = prevScreenNumber == 0 ? 500 : 0;
    let promoBanner = this.$refs.root.querySelector<HTMLElement>(".promo-banner--desktop")!;
    let line1 = this.$refs.root.querySelector<HTMLElement>(".line-1")!;
    let line2 = this.$refs.root.querySelector<HTMLElement>(".line-2")!;
    let line3 = this.$refs.root.querySelector<HTMLElement>(".line-3")!;

    anime({
      targets: promoBanner,
      opacity: [0, 1],
      duration: 700,
      easing: "easeOutQuad",
      delay: 400 + delay
    });

    anime({
      targets: line1.firstChild,
      translateY: ["100%", "0%"],
      duration: 1300,
      easing: "easeInOutQuad",
      delay: delay
    });

    anime({
      targets: line2.children,
      translateY: ["100%", "0%"],
      duration: 1300,
      easing: "easeInOutQuad",
      delay: (el, index) => {
        return (delay + 400) + (100 * index);
      }
    });

    anime({
      targets: line3.firstChild,
      translateY: ["100%", "0%"],
      duration: 1300,
      easing: "easeInOutQuad",
      delay: 800 + delay
    });

    this.buttonsEnter(prevScreenNumber);
    (anime as any).set(this.$refs.textBlock.firstChild, { opacity: 1, translateY: 0 });
  }


  textLeave() {
    let promoBanner = this.$refs.root.querySelector<HTMLElement>(".promo-banner--desktop")!;
    anime({
      targets: promoBanner,
      opacity: [1, 0],
      duration: 700,
      easing: "easeOutCubic"
    });
    anime({
      targets: this.$refs.textBlock.firstChild,
      translateY: [0, "-45vh"],
      opacity: [1, 0],
      duration: 600,
      easing: "linear",
    });
  }


  buttonsEnter(prevScreenNumber: number) {
    let delay = prevScreenNumber == 0 ? 500 : 0;
    let buttons = this.$refs.root.querySelector<HTMLElement>(".buttons")!;
    if (!this.scrollingByScreens) (anime as any).set(buttons, { translateX: "-50%" });
    anime({
      targets: buttons,
      translateY: [100, 0],
      opacity: [0, 1],
      duration: 1500,
      easing: "easeOutCubic",
      delay: 1200 + delay
    });
  }
}
